// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://127.0.0.1:8008/crm_backend/',
  // apiUrl: 'http://10.147.23.166:90/crm/',
  // apiPdfContratto: 'https://aurea.k4eb.it/k4eb/',

  apiUrl: 'https://api.energon.ecogroup-italy.it/api/',
  apiPdfContratto: 'https://energon.ecogroup-italy.it',
  linear: true
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
